import React, { useState, useCallback } from 'react';
import ScanOrder from './ScanOrder';
import ScanLocation from './ScanLocation';
import ScanQty from './ScanQty';
import ScanSKU from './ScanSKU';
import { SetDefaultWarehouseDialog } from 'components/common';
import { fetchPickingByOrder } from 'services/smart';
import { fetchWarehouseLocationList } from 'services/warehouse';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { getWarehouseIdFromCache, getWarehouseCodeFromCache, getProfileSettingValue } from 'utils';

export default function PickList(): JSX.Element {
  const whs = useSelector(
    (state: RootState) => state.admin.warehouses,
    shallowEqual
  );
  const [locations, setLocations] = useState<any[]>([]);
  const [order, setOrder] = useState<SmartPickOrder>();
  const [scanedOrderStr, setScanedOrderStr] = useState('');
  const [location, setLocation] = useState<WarehouseLocationRow>();
  const [product, setProduct] = useState<SmartPickOrderItem>();
  const [pickedQty, setPickedQty] = useState(0);
  const [step, setStep] = useState<
    'scanOrder' | 'scanSKU' | 'scanLocation' | 'scanQty'
  >('scanOrder');
  const [dialogClosable, setDialogClosable] = React.useState(true);
  const [defaultWarehouseVisible, setDefaultWarehouseVisible] =
    React.useState(false);
  const [showCondition, setShowCondition] = useState(false)

  const openSetDefaultWarehouseDialog = (config: StringKAnyVPair) => {
    setDialogClosable(
      typeof config.closable === 'boolean' ? config.closable : true
    );
    setDefaultWarehouseVisible(true);
  };

  React.useEffect(() => {
    if (
      !localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY) ||
      !getWarehouseCodeFromCache(
        Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY))
      )
    ) {
      openSetDefaultWarehouseDialog({ closable: false });
    }
  }, []);
  React.useEffect(() => {
    if (whs) {
      const exist = whs.filter(
        (e) =>
          e.id === Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)) &&
          (e.warehouseType === 1 || e.warehouseType === 5)
      );
      if (exist.length === 0) {
        openSetDefaultWarehouseDialog({ closable: false });
      }
    }
  }, [whs]);

  const getSettings = useCallback(async () => {
    const res3 = await getProfileSettingValue('ShowProductCondition','0')

    setShowCondition(res3 === '1')
  }, [])

  React.useEffect(() => {
    getSettings()
  }, [getSettings])
  /**
   * handle SKU Finish
   */
  const handleSKUFinish = useCallback(
    async (scannedQty: number) => {
      if (order && product) {
        const { items } = order;
        order.items = items.map((item) => {
          if (
            // item.sku === product.sku ||
            // (item.upc === product.upc && product.upc
            item.fulfillmentOrderLineNum === product?.fulfillmentOrderLineNum
          ) {
            item.pickedQty = scannedQty;
          }
          return {
            ...item,
          };
        });
        setOrder({
          ...order,
        });
      }
    },
    [order, product]
  );

    const refreshOrder1 = async (
    ) => {
      try {
        const res = await fetchPickingByOrder(scanedOrderStr);
        if (res.isSuccess) {
          setOrder(res.data);
        }
      } catch (error) {
  
      }
    };

  const refreshOrder = async (
    nextStep: string,
    product?: SmartPickOrderItem,
    orderStr?: string
  ) => {
    try {
      const res = await fetchPickingByOrder(orderStr || scanedOrderStr);
      if (res.isSuccess) {
        setOrder(res.data);
        if (nextStep === 'scanLocation') {
          const temp = res.data.items.filter(
            (item: SmartPickOrderItem) =>
              item.fulfillmentOrderLineNum === product?.fulfillmentOrderLineNum
          );
          if (temp.length > 0) {
            setProduct(temp[0]);
            setPickedQty(temp[0].pickedQty);
          }
        }
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  const fetchLocations = async () => {
    try {
      const res = await fetchWarehouseLocationList(
        getWarehouseIdFromCache(
          Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY))
        ),
        false
      );
      setLocations(res);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    if (localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)) {
      fetchLocations();
    }
  }, []);

  return (
    <div style={{ marginTop: 20 }}>
      {step === 'scanOrder' && (
        <ScanOrder
          onSubmit={(nextOrder: SmartPickOrder, str: string) => {
            setOrder(nextOrder);
            setScanedOrderStr(str);
            setStep('scanSKU');
          }}
        />
      )}
      {step === 'scanSKU' && order && (
        <ScanSKU
          order={order}
          onBack={() => {
            setStep('scanOrder');
          }}
          onRefresh={() => refreshOrder1()}
          onSubmit={(nextProduct) => {
            setProduct(nextProduct);
            setPickedQty(nextProduct.pickedQty);
            setStep('scanLocation');
          }}
        />
      )}
      {step === 'scanLocation' && product && order && (
        <ScanLocation
          showCondition={showCondition}
          order={order}
          locations={locations}
          warehouseId={getWarehouseIdFromCache(
            Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY))
          )}
          product={product}
          onSubmit={(nextLocation) => {
            setLocation(nextLocation);
            setStep('scanQty');
          }}
          onBack={() => {
            setStep('scanSKU');
          }}
        />
      )}
      {step === 'scanQty' && order && location && product && (
        <ScanQty
          showCondition={showCondition}
          order={order}
          pickedQty={pickedQty}
          onChangeSKU={(nextProduct) => {
            refreshOrder('scanLocation', nextProduct);
            setStep('scanLocation');
          }}
          onChangeOrder={async (nextOrder) => {
            if (nextOrder) {
              // setOrder(nextOrder);
              const result = await refreshOrder(
                'scanSKU',
                undefined,
                nextOrder
              );
              if (result) {
                setScanedOrderStr(nextOrder);
                setStep('scanSKU');
              } else {
                setStep('scanOrder');
              }
            } else {
              setStep('scanOrder');
            }
          }}
          location={location}
          product={product}
          onBack={(nextStep) => {
            if (nextStep === 'scanSKU' || nextStep === 'scanLocation') {
              refreshOrder(nextStep, product);
            }
            setStep(nextStep);
          }}
          onFinish={handleSKUFinish}
        />
      )}
      {
        <SetDefaultWarehouseDialog
          closable={dialogClosable}
          close={() => {
            setDefaultWarehouseVisible(false);
          }}
          visible={defaultWarehouseVisible}
        />
      }
    </div>
  );
}
